import { render, staticRenderFns } from "./AppPrestazioni.vue?vue&type=template&id=405b2866&"
import script from "./AppPrestazioni.vue?vue&type=script&lang=js&"
export * from "./AppPrestazioni.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports